/**
 * 2019/1/16.
 * 作者:lzq
 * 功能: 日志管理求路径
 */

import BEHAVIORDIARY from './behaviorDiary';
import INTERFACELOG from './interfaceLog';
import LOGSTATISTICS from './logStatistics';
import LOGANALYSIS from './logAnalysis';

export default {
  BEHAVIORDIARY,
  INTERFACELOG,
  LOGSTATISTICS,
  LOGANALYSIS
};
